import { alpha, type Theme } from '@mui/material/styles';

export const drawerSectionCardSx = (theme: Theme, opts?: { height?: string }) => ({
  ...(opts?.height != null ? { height: opts.height } : {}),
  borderColor: theme.palette.divider,
  boxShadow: theme.palette.mode === 'dark' ? 'none' : '0 10px 20px -16px rgba(15, 23, 42, 0.35)',
});

export const drawerSectionTitleSx = (theme: Theme) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.info.light : '#312e81',
});

export const drawerHeroBannerSx = (theme: Theme) => ({
  mb: 2.5,
  p: 2,
  borderRadius: 2.5,
  border: `1px solid ${alpha(theme.palette.info.main, theme.palette.mode === 'dark' ? 0.35 : 0.28)}`,
  background:
    theme.palette.mode === 'dark'
      ? alpha(theme.palette.info.main, 0.14)
      : 'linear-gradient(135deg, #eff6ff 0%, #ecfeff 100%)',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 1,
});
